import '../scss/broker.scss';

import brokerLocator from './scripts/brokerLocator';

brokerLocator();